module.exports = __webpack_public_path__ + "img/video_thumb_03.d937192f.png";